module.exports = __webpack_public_path__ + "arvr-4e7be27a.webp";